<template>
  <div class="popup">
    <div class="popup-header">
      {{ $t("buttons.addreview") }} {{ this.username_by_id(this.contract.user_id) }} @ {{ planning.project_name }}
      <div class="popup-close" @click="$emit('close')">
        <font-awesome-icon icon="times" />
      </div>
    </div>
    <div class="popup-body">
      <b-container fluid>
        <div class="form-row">
          <div class="col-3">
            {{ $t("labels.emailsendersname") }}
          </div>
          <div class="col-8">
            <v-select v-if="false" :options="this.activeemailsenders.concat(authemailsenders)" label="name" v-model="sender" />
            <v-select v-if="useazure" :options="this.authemailsenders" label="name" v-model="sender" />
            <v-select v-if="usesmtp" :options="this.emailsenders" label="name" v-model="sender" />
          </div>
        </div>
        <div class="form-row">
          <div class="col-3">
            {{ $t("labels.sendto") }}
          </div>
          <div class="col-8">
            <v-select :options="this.cc_bcc_users" v-model="to">
              <template slot="option" slot-scope="option">
                {{ option.label }}
                <font-awesome-icon style="margin-right: 1rem; float: right" v-if="option.company_contact" icon="address-book" />
                <font-awesome-icon style="margin-right: 1rem; float: right" v-if="option.document_contact" icon="file" />
                <font-awesome-icon style="margin-right: 1rem; float: right" v-if="option.invoice_contant" icon="euro-sign" />
                <font-awesome-icon style="margin-right: 1rem; float: right" v-if="option.sign_contact" icon="pencil-alt" />
                <font-awesome-icon style="margin-right: 1rem; float: right" v-if="option.location_contact" icon="street-view" />
              </template>
            </v-select>
          </div>
        </div>
        <div class="form-row">
          <div class="col-3">
            {{ $t("titles.reviewquestions") }}
          </div>
          <div class="col-8">
            <v-select :options="this.reviewrequests" label="description" v-model="review" />
          </div>
        </div>
        <hr />
        <div class="form-row">
          <div class="col-3">
            {{ $t("titles.subject") }}
          </div>

          <div class="col-8">
            <b-input :state="subject != null && subject != ''" v-model="subject" required :placeholder="$t('titles.subject')" />
          </div>
        </div>

        <div id="app" :style="ckeditorState(editorData)">
          <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
        </div>
      </b-container>
    </div>
    <div class="popup-footer">
      <div v-if="to.id && review != null" @click="directfill" class="btn btn-primary">Direct invullen</div>

      <div v-if="!to.id || subject == null || subject == '' || editorData == null || editorData == '' || review == null" class="btn btn-primary">{{ $t("buttons.invalid") }}</div>
      <div v-else @click="save_and_close" class="btn btn-primary">{{ $t("buttons.sendrequest") }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import popup_confirm from './PopupConfirm.vue'

import axios from "axios";

export default {
  name: "send_review_modal",
  data() {
    return {
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        toolbar: {
          items: ["heading", "|", "undo", "redo", "-", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "insertTable"],
          shouldNotGroupWhenFull: true,
        },
        heading: {
          options: [
            { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
            { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
            { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
          ],
        },
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
        placeholder: this.$t("labels.message"),
      },
      sendcontact: 1,
      sendzzpr: 1,
      to: "",
      cc: [],
      selected: [],
      subject: "",
      reviewrequests: [],
      review: null,
      sender: null,
    };
  },
  props: {
    contract_id: Number,
  },

  mounted() {
    axios
      .get("/api/reviewrequest/all")
      .then((response) => {
        this.reviewrequests = response.data;
      })
      .catch(() => {});
  },
  computed: {
    contract() {
      return this.contract_id > 0 ? this.contract_by_id(this.contract_id) : this.contract_new;
    },
    planning() {
      return this.planning_by_id(this.contract.planning_id);
    },
    user() {
      return this.user_by_id(this.contract.user_id);
    },
    company() {
      return this.company_by_id(this.project_by_id(this.contract.project_id).company_id);
    },
    ...mapGetters(["planning_by_id", "project_by_id", "contract_by_id", "contracts_metas", "contract_new", "username_by_id", "user_by_id", "company_by_id", "owners", "server_url", "activeemailsenders", "useazure", "usesmtp"]),
    ...mapState(["users", "settings", "contracts", "current_user", "documents", "emailsenders", "authemailsenders", "emailsenders"]),

    cc_bcc_users() {
      let persons = [];
      this.company.contactpersons.forEach((aperson) => {
        if (this.user_by_id(aperson) && (this.user_by_id(aperson).blacklist == undefined || this.user_by_id(aperson).blacklist != 1)) {
          persons.push({ id: aperson, label: this.username_by_id(aperson), company_contact: this.user_by_id(aperson).company_contact == "1", document_contact: this.user_by_id(aperson).document_contact == "1", invoice_contant: this.user_by_id(aperson).invoice_contant == "1", sign_contact: this.user_by_id(aperson).sign_contact == "1", location_contact: this.user_by_id(aperson).location_contact == "1" });
        }
      });
      return persons;
    },
  },
  methods: {
    async directfill() {
      await axios.post("/api/reviewsend", { user_id: this.contract.user_id, reviewer_id: this.to.id, contract_id: this.contract.id, request_id: this.review.id }).then(async function (response) {
        console.log("reviewsendRESULT", response);
        if (response.status == 200) {
          let reviewsenddata = response.data;

          await axios.post("/api/get_review_user_hash/", reviewsenddata).then(async (response) => {
            console.log("succes", response);
            let encrypted = response.data;
            window.open(encrypted, "_blank");
          });
        }
      });
      this.$emit("close");
    },
    async save_and_close() {
      //let email=this.user_by_id(this.contract.user_id).email
      var vm = this;
      await axios.post("/api/reviewsend", { user_id: this.contract.user_id, reviewer_id: this.to.id, contract_id: this.contract.id, request_id: this.review.id }).then(async function (response) {
        console.log("reviewsendRESULT", response);
        if (response.status == 200) {
          let reviewsenddata = response.data;

          await axios.post("/api/get_review_user_hash/", reviewsenddata).then(async (response) => {
            console.log("succes", response);
            let encrypted = response.data;

            vm.editorData += '<br><br>Klik hier om het werk te beoordelen <br><br><br><a style="text-decoration: none;background-color: #FC8007; border-color: #FC8007;color:#fff;text-align: center; vertical-align: middle;	font-size: 1rem; line-height: 1.5; padding: 0.75rem 1.5rem; border-radius: 2rem;cursor: pointer;height:24px;width:240px;" href="' + encrypted + '">beoordelen</a>';
            let to_id = vm.to.id ? vm.to.id : vm.planning.sign_id;
            let name = vm.username_by_id(to_id);
            let message = {};
            // message.email = vm.user_by_id(vm.planning.sign_id).email
            message.email = vm.user_by_id(to_id).email;
            message.name = name;
            message.message = vm.editorData;
            message.subject = vm.subject;
            message.sender = vm.sender ? vm.sender.id : -1;
            message.sendermail = vm.sender ? vm.sender.email : -1;
            message.sendername = vm.sender ? vm.sender.name : -1;
            message.to = [];
            message.cc = [];
            // copy to sender
            if (vm.sender) {
              message.cc.push(vm.sender.email);
            }
            console.log("lets send", message);

            try {
              axios.post("/api/contact_user", message).then((response) => {
                console.log("succes", response);
                // if(response.data.status && response.data.status!="ok"){
                //     this.$modal.show(popup_confirm, {
                //     message:this.$t('validation.mailfailed'),
                //     header: this.$t('titles.mailfailed'),
                //     }, {
                //         name: 'popup_confirm',
                //         draggable: false,
                //         height: 'auto',
                //         width: '90%'
                //     })
                // }
              });
            } catch (err) {
              console.log(err);
            }
          });
        }
      });

      this.$emit("close");
    },
    ...mapActions(["add_contract", "generate_contract_company"]),
    hasdoc(id) {
      var _hasdoc = false;
      this.user.documents.forEach((adoc) => {
        if (!_hasdoc) {
          _hasdoc = adoc.name == id;
        }
      });
      return _hasdoc;
    },
    rowClass(item) {
      if (!item) return;
      var expireDate = null;
      this.user.documents.forEach((adoc) => {
        if (adoc.name == item) {
          expireDate = new Date(adoc.expires);
        }
      });
      if (item == "ID") {
        expireDate = new Date(this.user.identification_endate);
      }
      var today = new Date();
      var diff = (expireDate.getTime() - today.getTime()) / (1000 * 3600 * 24);
      if (diff < 2) {
        return "status-expires-dialog";
      }
      if (diff < 31) {
        return "status-expires-soon-dialog";
      }
      return "status-active-dialog";
    },
    docdate(id) {
      let ret = "";
      if (id == "ID") {
        ret = this.dateToNL(this.user.identification_endate);
      } else {
        this.user.documents.forEach((adoc) => {
          if (adoc.name == id) {
            // console.log("found", adoc)
            ret = this.dateToNL(adoc.expires);
          }
        });
      }
      return ret;
    },
    docto(id) {
      var _link = "";
      this.user.documents.forEach((adoc) => {
        if (adoc.name == id) {
          _link = adoc.link;
        }
      });
      return this.server_url + "/media_" + _link;
    },
  },
};
</script>
